import React from "react";
import PropTypes from "prop-types";
import AuxiliaryBubble from "../auxiliary-bubble";
import { getPositionInCircle } from "../../utils";

const AuxiliaryBubbleList = ({
  auxBubbles,
  onClick,
  radius,
  currentBubble,
  isActive,
  taggingInfo,
}) => {
  return (
    <>
      {Array.isArray(auxBubbles) &&
        auxBubbles.map((bubble, index) => (
          <AuxiliaryBubble
            icon={bubble["Glyph-1"]}
            text={bubble["Text-1"]}
            index={index}
            position={getPositionInCircle(index + 1, auxBubbles.length, radius)}
            onClick={onClick}
            isActive={isActive && currentBubble === index ? true : false}
            key={`bubble-${index}`}
            taggingInfo={taggingInfo}
          />
        ))}
    </>
  );
};

AuxiliaryBubbleList.propTypes = {};

export default AuxiliaryBubbleList;
